module.exports = __webpack_public_path__ + "static/media/icon-sem-agenda.bd0fd92a.svg";